<div class="container">
	<div class="loading" *ngIf="!activeVideoUrl">Loading Video...</div>
	<video #videoPlayer *ngIf="activeVideoUrl" (ended)="playNextVideo()" width="854" controls style="background:black" autoplay>
		<source src="{{activeVideoUrl}}">
	</video>
</div>